import * as API from "middleware/api";

export const addSkip = (number) => API.executeWithAccessToken("/tour.addSkip", { number });

export const readSkipsCounter = () => API.executeWithAccessToken("/tour.readSkipsCounter");
